var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNat22(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.339,
    height: 80.284,
    viewBox: "0 0 95.339 80.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34352",
    "data-name": "Group 34352",
    transform: "translate(-160.108 -421.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32487",
    "data-name": "Group 32487",
    transform: "translate(162 423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26731",
    "data-name": "Path 26731",
    d: "M4950.4,2234.883a72.781,72.781,0,0,0,8.317-2.364,27.654,27.654,0,0,0,14.871-12.455c2.611-4.656,5.627-6.728,7.692-7.646a2.66,2.66,0,0,0,.865-4.2c-4.917-5.514-20.214-10.9-33.6-6.033-12.142-5.465-24.893-8.071-39.126-3.725a25.106,25.106,0,0,0-17.607,20.281c-1.872,12.733.4,29.615,4.279,41.971a3.741,3.741,0,0,0,5.931,1.822c7.037-5.953,21.246-3.646,31.506-7.493a14.485,14.485,0,0,0,8.723-17.225c-1.451-5.654-2.212-15.23,3.381-27.228",
    transform: "translate(-4891.137 -2196.28)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26732",
    "data-name": "Path 26732",
    d: "M4915.807,2252.976c-4.288-24.852,2.145-33.45,22.085-35.913",
    transform: "translate(-4904.164 -2207.848)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26733",
    "data-name": "Path 26733",
    d: "M4923.264,2309.541s3.427-3.435,17.943-5.51c13.719-1.961,27.047-3.359,29.846-19.2a4.435,4.435,0,0,1,3.31-3.551c5.495-1.339,17.087-4.88,20.374-11.507a44.28,44.28,0,0,1,4.054-6.787",
    transform: "translate(-4909.02 -2233.407)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNat22);
export default __webpack_public_path__ + "static/media/nat2-2.5d0723b8d3a8810c03e3b0211f3c75c8.svg";
export { ForwardRef as ReactComponent };